<template>
  <div class="m-map" :id="!hidedata && showRightData?'changeConl':''">
    <div class="m-switch" v-if="!isShowHotCity">
      <el-switch
        class="swBor"
        @change="isShowCity"
        v-model="cityDataValue"
        active-color="#181B2B"
        inactive-color="#181B2B"
      ></el-switch>
      <span class="a">全部城市热力图</span>
      <el-switch
        class="swBor"
        @change="isShowRoad"
        v-model="roadValue"
        active-color="#181B2B"
        inactive-color="#181B2B"
      ></el-switch>
      <span class="a">全部道路热力图</span>
      <el-switch
        class="swBor"
        @change="isShowRoadCity"
        v-model="cityValue"
        active-color="#181B2B"
        inactive-color="#181B2B"
      ></el-switch>
      <span class="a">道路途径城市热力图</span>
    </div>
    <div
      class="amap-marker-label"
      v-if="showDetails && !hideClickDetails && hCityDetails.length>0"
      :style="{left:nLeft+'px',top:nTop+'px'}"
    >
      <div class="tipHover">
        <div class="th1">
          <span v-if="isShowHotCity" v-html="hCityDetails[0].highSpeedName"></span>
          <span
            v-else
            @click="goCity(hCityDetails[0].cityName,hCityDetails[0].cityCode)"
          >{{hCityDetails[0].cityName}}</span>
          <i class="el-icon-caret-right">
            <i class="el-icon-caret-right el-icon-caret-right1"></i>
          </i>
          <i @click="closeDetails" class="el-icon-close el-icon-close12"></i>
        </div>
        <div class="th2">
          <div>
            {{ isHotCity?hCityDetails[0].operations:hCityDetails[0].operationsRange}}
            <p>
              运营车次
              <br />（日均）
            </p>
          </div>
          <div>
            {{isHotCity?hCityDetails[0].gasStation:hCityDetails[0].gasStationRange}}
            <p>
              加油站停靠
              <br />（日均）
            </p>
          </div>
          <div>
            {{hCityDetails[0].logisticsPark}}
            <p>
              物流园停靠
              <br />（日均）
            </p>
          </div>
          <div>
            {{hCityDetails[0].density}}
            <p>
              {{mapType==1?'城市':'道路'}}加油站密度
              <br />（座/百公里）
            </p>
          </div>
          <div>
            {{hCityDetails[0].lugNumber }}
            <p>
              LNG车次
              <br />（日均）
            </p>
          </div>
        </div>
        <div style="color: #fff; display: flex; align-items: center;opacity: .5;padding-left: 10px;padding-bottom: 6px;">
          <img width="16" style="margin-right: 6px;" src="../../../assets/images/qur.png" />
          {{mapType==1?'城市加油站密度=油站数量/道路长度（基于TOP150条道路）':'道路加油站密度=油站数量/道路长度（基于当前道路）'}}
        </div>
      </div>
    </div>
    <!-- 运营次数查看 -->
    <div class="shown" v-if="showTotalNum" :style="{left:newLeft+'px',top:newTop+'px'}">
      <template v-if="onlyHSpeedName">道路名称：{{onlyHSpeedName}}，</template>
      运营车次：{{totalNum}}
    </div>
    <p
      class="m-tip"
    >{{isShowHotCity?'2018年'+hotZoneAreas[0].cityName+'公路运营热力图':'2018年度全国城市公路运营热力图'}}</p>
    <div id="js-container" class="map">正在加载数据 ...</div>
  </div>
</template>
<script>
import store from '@/store'

import remoteLoad from './remoteLoad.js'
import axios from '@/api/road.js'
import commonFun from '../assets/js/common.js'
import { mapMainUrl, uiMainUrl, mapConfigs, loadUIArr } from './config'
import { setTimeout } from 'timers'
import { constants } from 'crypto'
export default {
  data() {
    return {
      AMapUI: null,
      cityValue: true,
      roadValue: false,
      cityDataValue: true,
      AMap: null,
      isFinishMap:false,
      nLeft: 0,
      value: false,
      isValueData: { roadId: null },
      pathListData: [],
      nTop: 0,
      markerIndex: '',
      moveCityCode: null,
      showDetails: false,
      markerId: '',
      isDblClickM: false,
      showTotalNum: false, //是否展示运营车次
      totalNum: 0, //查看运营次数
      onlyHSpeedName: '', //查看道路名称
      newLeft: 0,
      newTop: 0,
      // isAutoSet:false,//是否需要自动变化
      // autoSet:
      hideClickDetails: false,
      zxCity: [110000, 120000, 310000, 500000]
      // isShowHotCity: false //是否展示全国或者城市
    }
  },
  props: {
    hidedata: Boolean,
    clickId: Number,
    isHotCity: Boolean,
    showRightData: Boolean,
    isShowHotCity: Boolean,
    isAutoSet: Boolean, //是否需要自动变化
    enableGeomSubmit: Boolean,
    mapType:Number,
    lnglats: {
      type: Array,
      default: () => {
        return []
      }
    },
    provinceCodes: {
      type: Array,
      default: () => {
        return []
      }
    },
    listDatas: {
      type: Array,
      default: () => {
        return []
      }
    },
    hCityDetails: {
      type: Array,
      default: () => {
        return []
      }
    },
    hotZoneAreas: {
      type: Array,
      default: () => {
        return []
      }
    },
    pathData: {
      type: Array,
      default: () => {
        return []
      }
    },
    allData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    getObjColor: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  watch: {
    listDatas(val, oldVal) {
      if (val) {
        if (this.isShowHotCity) {
          this.clearAllPath()
          setTimeout(function() {
            setMapCenter()
          }, 500)
        }
        // 判断是否开启全部道路热力图 为开启单条加载  清除上次绘制的路线
        if (!this.roadValue) {
          this.clearAllPath()
        }
        var listDatas = this.changeLsData(val)
        listDatas.length > 0
          ? pathSimplifierData(listDatas)
          : pathSimplifierData([])
      }
    },
    pathData(val, oldVal) {
      if (val) {
        var pathData = this.changeLsData(val)
        pathData.length > 0 ? pathSimplifierData(pathData) : ''
      }
    },
    allPathData(val, oldVal) {
      if (val) {
        var allPathData = this.changeLsData(val)
        allPathData.length > 0
          ? pathSimplifierIns.setData(allPathData)
          : pathSimplifierIns.setData(null)
      }
    },
    lnglats(val, oldVal) {
      if (val) {
        showMarks()
      }
    },
    hotZoneAreas(val, oldVal) {
      if (val) {
        if (this.cityValue) {
          this.changeHotData(val)
        }
      }
    },
    hCityDetails(val, oldVal) {
      if (val) {
        this.hCityDetails = val
        this.showDetails = true
      }
    }
  },
  methods: {
    getNewPLimit() {
      var menuList = store.getters.menuList
      var libList = menuList[menuList.length - 1]
      // 热力图操作站点权限
      if (libList.id === 415) {
        var limit = libList.libList
        var zdLimit = limit[limit.length - 1]
        if (zdLimit.id == 417) {
          this.newPosLimit = true
        }
      }
      // this.newPosLimit = true
    },
    // 运营车次详情查看
    totalNumFun(num, onlyHSpeedName, e) {
      var ww = document.body.clientWidth - 470
      var wh = document.body.clientHeight - 50
      var x = e.x + 10
      var y = e.y + 10
      if (x > ww) {
        x = x - 200
      }
      if (y > wh) {
        y = y - 50
      }
      this.newLeft = x
      this.newTop = y
      this.totalNum = num
      this.onlyHSpeedName = onlyHSpeedName
      this.showTotalNum = true
    },
    showPosData(e, code, id) {
      var ww = document.body.clientWidth - 600
      var wh = document.body.clientHeight - 140
      var x = e.x
      var y = e.y
      if (x > ww) {
        x = x - 600
      }
      if (y > wh) {
        y = y - 140
      }
      this.nLeft = x
      this.nTop = y
      this.$emit('getHCityDetails', code, id)
    },
    closeDetails() {
      this.showDetails = false
    },
    goCity(code, name) {
      this.$router.push({
        path: '/roadOperation/hotCities',
        query: {
          id: 0,
          cityName: code,
          cityCode: name,
          isHotCity: false
        }
      })
    },
    // 处理路线paths
    changeLsData(listDatas) {
      var pathsData = []
      for (var v of listDatas) {
        if (v.paths) {
          if (v.paths.length) {
            pathsData = pathsData.concat(v.paths)
          }
        }
      }
      // 过滤不是当前城市的坐标
      if (this.isShowHotCity) {
        for (var k = 0; k < pathsData.length; k++) {
          if (pathsData[k].cityCode != this.hotZoneAreas[0].cityCode) {
            pathsData.splice(k, 1)
            k = k - 1
          }
        }
      }
      return pathsData
    },
    // 添加或者编辑站点
    showNewPos(e, isAdd, obj) {
      // 无权限操作站点
      if (this.newPosLimit) {
        this.$emit('showNewPos', e, isAdd, obj)
      }
    },
    // 删除站点
    reMoveMark() {
      // 无权限操作站点
      if (this.newPosLimit) {
        axios.deleteSide({ id: this.markerId }).then(e => {
          if (e.code == 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.$emit('getSiteList')
          } else {
            this.$message({
              message: e.message,
              type: 'warning'
            })
          }
        })
      }
    },
    // 清空所有的路线绘画
    clearAllPath() {
      for (var v of pathSimplifierInsData) {
        v.setData([])
      }
    },
    clearAllSite() {
      map.clearMap()
    },
    // 全部道路
    isShowRoad() {
      if (this.roadValue) {
        this.$emit('loadMorePath')
        map.setZoom(6)
      } else {
        // 循环清空画线对象
        this.clearAllPath()
        // 判断是否存在某条道路
        var listDatas = this.changeLsData(this.listDatas)
        listDatas.length > 0
          ? pathSimplifierIns.setData(listDatas)
          : pathSimplifierIns.setData([])
      }
    },
    // 处理热区
    changeHotData(hotZoneAreas, isopen) {
      var _this = this,
        adcodess = []
      for (var v of hotZoneAreas) {
        if (parseInt(v.cityCode)) {
          if (adcodess.indexOf(v.citycode) == -1) {
            adcodess.push(parseInt(v.cityCode))
          }
        }
      }
      _this.codesArr = adcodess
      if (isopen) {
        _this.codesArr = null
      }
      loadDatas()
    },
    // 全部城市热力图开关
    isShowCity() {
      if (this.cityDataValue) {
        this.$emit('openAllCity')
      } else {
        if (this.cityValue && this.clickId != 0) {
          this.$emit('openRoadCity')
        } else {
          this.changeHotData([], true)
        }
      }
    },
    // 某条道路热区城市
    isShowRoadCity() {
      if (!this.cityDataValue) {
        if (this.cityValue) {
          this.$emit('openRoadCity')
        } else {
          this.changeHotData([], true)
        }
      }
    },
    // 实例化地图
    initMap() {
      var _this = this
      let AMapUI = (this.AMapUI = window.AMapUI)
      let AMap = (this.AMap = window.AMap)
      AMapUI.load(loadUIArr, function(
        PathSimplifier,
        PositionPicker,
        DistrictExplorer,
        BasicControl,
        $
      ) {
        if (!PathSimplifier.supportCanvas) {
          alert('当前环境不支持 Canvas！')
          return
        }
        let mapConfig = mapConfigs
        var clickListener,
          dbclickListener,
          map = new AMap.Map('js-container', mapConfig)
        // 地图加载完成！
        map.on('complete', function() {
          // console.log("完成")
          // 加载热门城市道路
          if (_this.isShowHotCity) {
            _this.isFinishMap=true
          }
        })
        window.map = map
        map.on('zoomstart', mapZoom)
        // 判断是都是全部道路是给zoom 最大6
        function mapZoom() {
          if (_this.roadValue) {
            if (map.getZoom() >= 7) {
              map.setZoom(6)
            }
            return
          }
        }
        map.on("zoomchange",function(){
          // console.log(1)
           if (!_this.isShowHotCity) {
              mapZoom()      
           }
        }) 
        function setMapCenter(arr) {
          //  map.setCenter(arr)
          map.setZoom(9)
        }
        window.setMapCenter = setMapCenter
        // AMapUI.loadUI(['control/BasicControl'], function(BasicControl) {
        //缩放控件，显示Zoom值
        map.addControl(
          new BasicControl.Zoom({
            position: 'rb',
            showZoomNum: true
          })
        )
        // })
        // 显示站点
        var infoWindow = new AMap.InfoWindow({
          offset: new AMap.Pixel(0, -30)
        })
        // 创建一个 Icon
        var startIcon = new AMap.Icon({
          // 图标尺寸
          size: new AMap.Size(36, 59),
          // 图标的取图地址
          image: require('./p.png'),
          // 图标所用图片大小
          imageSize: new AMap.Size(18, 29)
        })
        var markers = []
        showMarks()
        function showMarks() {
          var lnglats = _this.lnglats
          _this.isDblClickM = false
          // map.clearMap()
          map.remove(markers)
          for (var i = 0, marker; i < lnglats.length; i++) {
            var marker = new AMap.Marker({
              position: lnglats[i].coordinateArr,
              map: map,
              cursor: 'pointer',
              zIndex: 100,
              icon: startIcon,
              offset: new AMap.Pixel(-10, -19),
              extData: {
                markIndex: i,
                id: lnglats[i].id,
                obj: lnglats[i]
              }
            })
            var remarks = lnglats[i].remarks ? lnglats[i].remarks : ''
            if (lnglats[i].companyName) {
              var cName = ''
              var cKey = ''
              var ctName = ''
              var ctKey = ''
              if (lnglats[i].companyName.length > 20) {
                cName = JSON.parse(lnglats[i].companyName).companyName
                cKey = JSON.parse(lnglats[i].companyName).companyKey
                ctName = JSON.parse(lnglats[i].cityName).cityName
                ctKey = JSON.parse(lnglats[i].cityName).cityKey
              } else {
                cName = lnglats[i].companyName
                cKey = lnglats[i].companyKey
                ctName = lnglats[i].cityName
                ctKey = lnglats[i].cityKey
              }
              marker.content =
                '<div>' +
                cKey +
                '：' +
                cName +
                '</div><div>' +
                ctKey +
                '：' +
                ctName +
                '</div><div>销量：' +
                lnglats[i].sale +
                '</div><div>经纬度：' +
                lnglats[i].coordinateArr +
                '</div><div>备注：' +
                remarks +
                '</div>'
            }
            marker.on('click', markerClick)
            //
            //绑定鼠标右击事件——弹出右键菜单
            marker.on('rightclick', function(e) {
              if (_this.newPosLimit) {
                _this.markerIndex = e.target.B.extData.markIndex
                _this.markerId = e.target.B.extData.id
                contextMenu.open(map, e.lnglat)
              }
            })
            // }
            marker.on('mouseover', markerClick)
            marker.on('mouseout', markermouseout)
            marker.on('dblclick', markerEdit)

            markers.push(marker)
          }
        }
        window.showMarks = showMarks
        //创建右键菜单
        var contextMenu = new AMap.ContextMenu()
        contextMenu.addItem(
          ' 删 除 ',
          function() {
            markers[_this.markerIndex].setMap(null)
            _this.reMoveMark()
          },
          0
        )
        function markerClick(e) {
          infoWindow.setContent(e.target.content)
          infoWindow.open(map, e.target.getPosition())
        }
        function markermouseout(e) {
          infoWindow.close(map, e.target.getPosition())
        }
        function markerEdit(e) {
          _this.isDblClickM = true
          infoWindow.close(map, e.target.getPosition())
          var obj = e.target.B.extData.obj
          _this.showNewPos(e.pixel, false, obj)
        }
        // 监听地图点击事件
        clickListener = AMap.event.addListener(map, 'click', function(e) {
          // 双击和点击判断
          if (!_this.isShowHotCity) {
            _this.mapClick = false
            _this.hideClickDetails = true
            setTimeout(function() {
              if (!_this.mapClick) {
                _this.hideClickDetails = false
              }
            }, 750)
          }
          // 补修道路
          if (_this.isValueData.roadId && _this.enableGeomSubmit) {
            var list = _this.pathListData
            var x = e.lnglat.lng
            var y = e.lnglat.lat
            list.push([x, y])
          }
        })
        //  clickListener = AMap.event.addListener(map, 'rightclick', function(e) {
        //   //  _this.markerIndex = e.target.B.extData.markIndex
        //         // _this.markerId = e.target.B.extData.id
        //         // contextMenu.open(map, e.lnglat)
        // })
        // 监听地图双击事件
        dbclickListener = AMap.event.addListener(map, 'dblclick', function(e) {
          if (!_this.isShowHotCity) {
            _this.mapClick = true
          }

          if (!_this.isDblClickM) {
            AMap.service('AMap.Geocoder', function() {
              //回调函数 实例化Geocoder 获取城市名称 创建站点
              var geocoder = new AMap.Geocoder({
                city: '' //城市，默认：“全国”
              })
              var cityName = ''
              var lnglatXY = [e.lnglat.getLng(), e.lnglat.getLat()] //地图上所标点的坐标
              geocoder.getAddress(lnglatXY, function(status, result) {
                if (status === 'complete' && result.info === 'OK') {
                  cityName = result.regeocode.addressComponent.city
                    ? result.regeocode.addressComponent.city
                    : result.regeocode.addressComponent.province
                  if (_this.isShowHotCity) {
                    if (cityName !== _this.hotZoneAreas[0].cityName) {
                      return
                    }
                  }
                  _this.showNewPos(e.pixel, true, {
                    coordinateX: e.lnglat.lng + ',' + e.lnglat.lat,
                    cityName: cityName,
                    cityCode: result.regeocode.addressComponent.citycode
                  })
                  var lnglats = _this.lnglats
                  lnglats.push({
                    coordinateArr: [e.lnglat.lng, e.lnglat.lat]
                  })
                  _this.lnglats = lnglats
                  showMarks()
                } else {
                  console.log('获取失败')
                  //获取地址失败
                }
              })
            })
          }
        })

        //创建一个实例 热区面积
        var districtExplorer = new DistrictExplorer({
          eventSupport: true,
          map: map
        })
        //创建一个辅助Marker，提示鼠标内容
        var tipMarker = new AMap.Marker({
          //启用冒泡，否则click事件会被marker自己拦截
          bubble: true,
          icon: new AMap.Icon({
            image: null,
            size: new AMap.Size(0, 0), //图标大小
            imageSize: new AMap.Size(0, 0)
          })
        })
        //监听feature的hover事件
        districtExplorer.on(
          'featureMouseout featureMouseover featureClick',
          function(e, feature) {
            var isHover = e.type === 'featureMouseover'
            var isClick = e.type === 'featureClick'
            var isOut = e.type === 'featureMouseout'
            var props = feature.properties
            //更新相关多边形的样式
            var polys = null
            if (_this.zxCity.indexOf(props.acroutes[1]) != -1) {
              polys = districtExplorer.findFeaturePolygonsByAdcode([
                props.acroutes[1]
              ])
            } else {
              polys = districtExplorer.findFeaturePolygonsByAdcode([
                props.adcode
              ])
            }
            if (!_this.isShowHotCity) {
              for (var i = 0, len = polys.length; i < len; i++) {
                polys[i].setOptions({
                  fillOpacity: isHover && !_this.roadValue ? 1 : 0.6
                })
              }
            }
            // if (!isHover) {
            //   tipMarker.setMap(null)
            //   return
            // }

            if (!_this.isShowHotCity && isClick) {
              // if (!_this.cityDataValue) {
              //   return
              // }
              //  鼠标放上去获取热区详情
              // if (_this.moveCityCode != feature.properties.acroutes[1]) {
              var cityCodes = feature.properties.acroutes[1]
              if (_this.zxCity.indexOf(parseInt(cityCodes)) !== -1) {
                var acroutes = cityCodes
              } else {
                var acroutes = feature.properties.adcode
              }
              //   _this.$emit('getHCityDetails', acroutes[acroutes.length - 1])
              // }
              // _this.moveCityCode = feature.properties.acroutes[1]
              // var hCityDetails = _this.hCityDetails
              if (_this.codesArr) {
                if (_this.codesArr.indexOf(acroutes) != -1) {
                  _this.showPosData(e.originalEvent.pixel, acroutes)
                }
              }
            }
          }
        )
        window.districtExplorer = districtExplorer
        function loadDatas() {
          var adcodes = _this.provinceCodes
          if (_this.isShowHotCity) {
            adcodes = [_this.hotZoneAreas[0].cityCode]
          }
          districtExplorer.loadMultiAreaNodes(adcodes, function(
            error,
            areaNodes
          ) {
            //  设置定位节点，支持鼠标位置识别 注意节点的顺序，前面的高优先级
            districtExplorer.setAreaNodesForLocating(areaNodes)
            //清除已有的绘制内容
            districtExplorer.clearFeaturePolygons()
            for (var i = 0, len = areaNodes.length; i < len; i++) {
              renderAreaNode(areaNodes[i])
            }
            //更新地图视野
            map.setFitView(districtExplorer.getAllFeaturePolygons())
            // //清除已有的绘制内容
            // districtExplorer.clearFeaturePolygons()
            // for (var i = 0, len = areaNodes.length; i < len; i++) {
            //   if (areaNodes[i]) {
            //     renderAreaNode(areaNodes[i])
            //   }
            // }
            // //更新地图视野
            // map.setFitView(districtExplorer.getAllFeaturePolygons())
          })
        }
        var zxCity = _this.zxCity
        var getObjColor = _this.getObjColor
        function renderAreaNode(areaNode) {
          var codesArr = _this.codesArr
          districtExplorer.renderSubFeatures(areaNode, function(feature, i) {
            if (_this.isShowHotCity) {
              return {
                cursor: 'default',
                bubble: true,
                strokeColor: _this.isShowHotCity ? '#498AFF' : '#FFFFFF', //线颜色
                strokeOpacity: 0.3, //线透明度
                strokeWeight: 0.5, //线宽
                fillColor: _this.isShowHotCity
                  ? '#498AFF'
                  : getObjColor[feature.properties.adcode], //填充色
                fillOpacity: _this.isShowHotCity ? 0.1 : 0.3 //填充透明度
              }
            } else {
              if (codesArr) {
                if (codesArr.indexOf(feature.properties.adcode) != -1) {
                  return {
                    cursor: 'default',
                    bubble: true,
                    strokeColor: _this.isShowHotCity ? '#498AFF' : '#FFFFFF', //线颜色
                    strokeOpacity: 0.3, //线透明度
                    strokeWeight: 0.5, //线宽
                    fillColor: _this.isShowHotCity
                      ? '#498AFF'
                      : getObjColor[feature.properties.adcode], //填充色
                    fillOpacity: _this.isShowHotCity ? 0.1 : 0.3, //填充透明度
                    extData: {
                      code: feature.properties.adcode
                    }
                  }
                }
              } else {
                districtExplorer.clearFeaturePolygons()
              }
            }
          })
          //绘制父区域
          if (
            zxCity.indexOf(parseInt(areaNode.adcode)) != -1 &&
            !_this.isShowHotCity
          ) {
            districtExplorer.renderParentFeature(areaNode, {
              cursor: 'default',
              bubble: true,
              strokeColor: '#FFFFFF', //线颜色
              strokeOpacity: 0.3, //线透明度
              strokeWeight: 0.5, //线宽
              fillColor: getObjColor[areaNode.adcode], //填充色
              fillOpacity: 0.3

              //填充透明度
            })
          }
        }

        window.loadDatas = loadDatas
        // 首次加载所有的热区
        _this.changeHotData(_this.hotZoneAreas)
        // 城市详情
        if (_this.isShowHotCity) {
          // loadDatas([_this.hotZoneAreas[0].cityCode])
          loadDatas()
        }
        // 绘画道路 函数
        var pathSimplifierInsData = []
        function pathSimplifierData(pds) {
          var pathSimplifierIns = new PathSimplifier({
            zIndex: 100,
            autoSetFitView: _this.isAutoSet == true ? true : false,
            map: map, //所属的地图实例
            eventSupport: true,
            getPath: function(pathData, pathIndex) {
              return pathData.path
            },
            getHoverTitle: function(pathData, pathIndex, pointIndex) {
              var str = ''
              // if (!_this.isShowHotCity) {
              //   if (pathData.roadId == _this.clickId) {
              //     str =
              //       '<div class="shown">运营车次：' + pathData.total + '</div>'
              //   }
              // }
              return null
            },
            renderOptions: {
              pathLineStyle: {
                dirArrowStyle: false
              },
              getPathStyle: function(pathItem, zoom) {
                var color = pathItem.pathData.color,
                  i = pathItem.pathData.roadId == _this.clickId ? 5 : 1,
                  lineWidth = Math.round(i * Math.pow(1.1, zoom - 3))
                return {
                  pathLineStyle: {
                    strokeStyle: color,
                    lineWidth: lineWidth,
                    borderStyle: null
                  },
                  startPointStyle: null,
                  endPointStyle: null,
                  pathLineHoverStyle: {
                    strokeStyle: color,
                    lineWidth: lineWidth,
                    borderStyle: null,
                    dirArrowStyle: null
                  },
                  pathLineSelectedStyle: {
                    strokeStyle: null,
                    lineWidth: null,
                    borderStyle: null,
                    dirArrowStyle: null
                  },
                  pathNavigatorStyle: {
                    fillStyle: color
                  }
                }
              }
            }
          })
          pathSimplifierInsData.push(pathSimplifierIns)
          window.pathSimplifierIns = pathSimplifierIns
          window.pathSimplifierInsData = pathSimplifierInsData
          //首次加载全部道路路线
          pathSimplifierIns.setData(pds)
          pathSimplifierIns.on(
            'pointClick pathClick pointMouseover pointMouseout',
            function(e, info) {
              var isClick = e.type
              if (_this.enableGeomSubmit) {
                var roadId = _this.isValueData.roadId
                _this.isValueData = info.pathData
                if (roadId == info.pathData.roadId) {
                  _this.isValueData.path = _this.pathListData
                  if (_this.isValueData.roadId != 0) {
                    axios.addGeom(_this.isValueData).then(e => {
                      if (e.code == 200) {
                        _this.$message({
                          message: '添加成功',
                          type: 'success'
                        })
                      } else {
                        _this.$message({
                          message: e.message,
                          type: 'warning'
                        })
                      }
                      _this.isValueData.roadId = null
                    })
                    _this.pathListData = []
                  }
                  //_this.value = false
                } else {
                  // 第一次点击
                  var pathList = _this.pathListData
                  var x = e.originalEvent.lnglat.lng
                  var y = e.originalEvent.lnglat.lat
                  var newdata = [x, y]
                  if (pathList.length == 0) {
                    pathList.push([x, y])
                  }
                  for (var i = 0; i < pathList.length; i++) {
                    if (
                      !pathList[i].sort().toString() ===
                      newdata.sort().toString()
                    ) {
                      pathList.push([x, y])
                    }
                  }
                  _this.isValueData.roadId = info.pathData.roadId
                  _this.pathListData = pathList
                }
              } else {
                if (isClick == 'pointClick' || isClick == 'pathClick') {
                  if (!_this.isShowHotCity) {
                    _this.mapClick = true
                  }
                  _this.$emit('changeLeftIndex', info.pathData.roadId)
                }
                if (_this.isShowHotCity) {
                  if (isClick == 'pointMouseover') {
                    //  鼠标放上去获取运营详情
                    if (_this.signRoadId == info.pathData.roadId) {
                      _this.showDetails = true
                    } else {
                      _this.showPosData(
                        e.originalEvent.pixel,
                        _this.hotZoneAreas[0].cityName,
                        info.pathData.roadId
                      )
                    }
                    _this.signRoadId = info.pathData.roadId
                  }
                  if (isClick == 'pointMouseout') {
                    _this.showDetails = false
                  }
                } else {
                  // /鼠标放上去 查看运营次数
                  if (isClick == 'pointMouseover') {
                    _this.totalNumFun(
                      info.pathData.total,
                      info.pathData.highSpeedName,
                      e.originalEvent.pixel
                    )
                  }
                  if (isClick == 'pointMouseout') {
                    _this.showTotalNum = false
                  }
                }
              }
            }
          )
          if (_this.roadValue && !_this.isShowHotCity) {
            map.setZoom(6)
          }
        }
        window.pathSimplifierData = pathSimplifierData
        pathSimplifierData(_this.changeLsData(_this.pathData))
      })
    }
  },
  async created() {
    var _this = this
    // 是否有编辑站点权限
    setTimeout(() => {
      _this.getNewPLimit()
    }, 1000)
    // 已载入高德地图API，则直接初始化地图
    if (window.AMap && window.AMapUI) {
      this.initMap()
      // 未载入高德地图API，则先载入API再初始化
    } else {
      await remoteLoad(mapMainUrl)
      await remoteLoad(uiMainUrl)
      this.initMap()
    }
  }
}
</script>
<style>
.amap-ui-pathsimplifier-container .overlay-title:after,
.amap-ui-pathsimplifier-container .overlay-title:before {
  border: 0 !important;
  border-width: 0 !important;
}
.amap-ui-pathsimplifier-container .overlay-title {
  background: none !important;
  border: 0 !important;
}
.amap-vectors {
  z-index: 1 !important;
}
</style>

<style lang="css">
.m-map {
  min-height: 600px;
  overflow: auto;
  background: #000000;
  position: relative;
}
.m-map .map {
  width: 100%;
  height: 100%;
}
.m-map .search {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 285px;
  z-index: 1;
}
.m-map .search input {
  width: 180px;
  border: 1px solid #ccc;
  line-height: 20px;
  padding: 5px;
  outline: none;
}
.m-map .m-switch {
  position: absolute;
  z-index: 100;
  top: 130px;
  font-size: 10px;
  left: 320px;
  color: #fff;
}
.m-map .mapZoomBar {
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.5);
  border-radius: 3px;
}
.m-map .amap-ui-control-zoom {
  width: 34px;
  border: none;
}
.m-map .amap-ui-control-theme-light .amap-ui-control-zoom {
  background: #303553;
}
.m-map .amap-ui-control-theme-light .amap-ui-control-zoom a,
.m-map .amap-ui-control-theme-light .amap-ui-control-zoom-num {
  position: relative;
  width: 34px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  color: #d8d8d8;
  border: none;
  background: #303553;
}
.m-map .amap-ui-control-position-rb {
  bottom: 5%;
}
#changeConl .amap-ui-control-position-rb {
  right: 330px;
}
.m-map .amap-ui-control-theme-light .amap-ui-control-zoom a:hover {
  background: #50557a;
  cursor: pointer;
}
.m-map .amap-ui-control-theme-light .amap-ui-control-zoom-num {
  margin: 0 5px;
  width: 24px;
  border-top: 1px solid #303553;
  border-bottom: 1px solid #303553;
}
.m-map .amap-ui-control-theme-light .amap-ui-control-zoom a.disabled {
  background: #303553;
}
.mapZoomBar .item {
  position: relative;
  width: 34px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #7b82ac;
}
.m-map .m-switch span.a {
  opacity: 0.6;
}
.m-map .swBor .el-switch__core {
  border: 1px solid rgb(101, 105, 128) !important;
}
.m-map .is-checked .el-switch__core {
  border: 1px solid #66de94 !important;
}
.m-map .is-checked .el-switch__core:after {
  background-color: #66de94 !important;
}
.m-map .el-switch__core {
  margin-top: -3px;
  margin-left: 20px;
  margin-right: 10px;
}
.m-map .search button {
  line-height: 26px;
  background: #fff;
  border: 1px solid #ccc;
  width: 50px;
  text-align: center;
}
.m-map .result {
  max-height: 300px;
  overflow: auto;
  margin-top: 10px;
}
.m-map .amap-info-sharp {
  display: none;
}
.m-map .btn:hover {
  cursor: pointer;
}
.m-map .m-tip {
  font-size: 18px;
  color: #fff;
  position: absolute;
  top: 70px;
  z-index: 100;
  left: 340px;
}
.m-map .amap-info-content {
  background: rgba(0, 0, 0, 0.59);
  color: #fff;
  padding: 20px;
  font-size: 10px;
}
.m-map .tipHover {
  width: 580px;
  padding: 20px 10px;
  padding-bottom: 0;
  z-index: 9001;
  position: relative;
}
.m-map .tipHover .el-icon-caret-right {
  position: relative;
  color: #03dd94;
}
.m-map .tipHover .el-icon-caret-right1 {
  position: absolute;
  left: 10px;
}
.m-map .amap-marker-label {
  background-color: unset;
  z-index: 9001;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.7);
  border: none;
}
.m-map .shown {
  color: #fff;
  left: 100px;
  top: 100;
  position: absolute;
  z-index: 500;
}
.m-map .th1 {
  font-size: 18px;
  padding-left: 10px;
  color: #ffffff;
  font-weight: bold;
}
.m-map .th1 span:hover {
  cursor: pointer;
}
.m-map .th2 {
  font-size: 10px;
  margin-top: 13px;
  color: #ffffff;
}
.m-map .th2 > div {
  display: inline-block;
  width: 20%;
  vertical-align: top;
  text-align: center;
}
.m-map .th2 > div p {
  font-size: 10px;
  margin-top: 8px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.5);
}
.m-map .m-font0 {
  font-size: 12px;
  color: #fff;
  position: absolute;
  top: 110px;
  z-index: 9000;
  left: 340px;
}
.m-map .m-font0 span {
  color: #498aff;
}
.m-map .el-icon-close12 {
  font-size: 20px;
  font-weight: bold;
  margin-top: -4px;
  float: right;
}
.m-map .el-icon-close12:hover {
  cursor: pointer;
}
</style>